import { render } from "./ClientPage.vue?vue&type=template&id=24eb9af0"
import script from "./ClientPage.vue?vue&type=script&lang=js"
export * from "./ClientPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__